// export const BASE_URL = process.env.NODE_ENV === 'production' ? "https://app.invoxzy.com" : "http://localhost:5002";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_API = process.env.REACT_APP_BASE_URL;

